export default "__VITE_PUBLIC_ASSET__1f2655f3__"